import { httpRequest } from "../../http";
import { CatalogMetricType } from "@models/catalog.model";

export class CommandListMetricTypes {
  async run(): Promise<CatalogMetricType[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/catalog/metric-types/`;
    return httpRequest<CatalogMetricType[]>(url, { method: "GET" });
  }
}
